// src/components/dashboard/ProductsTable.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const ProductsTable = ({ products }) => {
  // Format currency for sales
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Function to determine stock status styling
  const getStockStatusStyle = (stock) => {
    if (stock <= 5) {
      return 'bg-red-100 text-red-800'; // Critical
    } else if (stock <= 10) {
      return 'bg-yellow-100 text-yellow-800'; // Low
    } else if (stock <= 20) {
      return 'bg-red-100 text-red-800'; // Medium
    } else {
      return 'bg-green-100 text-green-800'; // Good
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Product
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              SKU
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Stock
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Sales
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {products.map((product) => (
            <tr key={product.id} className="hover:bg-gray-50 transition-colors duration-150">
              <td className="px-6 py-4 whitespace-nowrap">
                <Link 
                  to={`/inventory/view/${product.id}`}
                  className="text-red-600 hover:text-red-900 font-medium"
                >
                  {product.name}
                </Link>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {product.sku}
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStockStatusStyle(product.stock)}`}>
                  {product.stock} units
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {formatCurrency(product.sales || 0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductsTable;